
import { useServiceRunsContext } from "../../../app/modules/ServiceRuns/context/ServiceRuns-context";
import { FC, useEffect, useState } from 'react'

export interface TableSelectInterface {
    params: {
        field: string,
        value: string | number;
        row: {[key:string]: number |boolean | string}
    },
    options: { name?: string, value?: string | number, disableDependency?: { field: string, value: string[] } }[]
}

export const TableSelect: FC<TableSelectInterface> = ({
    params,
    options
}) => {
    const { setRecords, setTableErrors, initialRecords } = useServiceRunsContext();
    const [touched, setTouched] = useState(false);
    const [erorred, setErorred] = useState(false);
    const [initialValue, setInitialValue] = useState(initialRecords.find(record => +record.id === params.row.id)?.[params.field] ?? '');
    const [newValue, setNewValue] = useState(params.value);

    useEffect(() => {
        console.log(params)
        setTouched(initialValue !== newValue);
        if (newValue !== params.value) {
            setRecords(prev => prev.map(record =>
                +record.id === params.row.id ? { ...record, [params.field]: newValue, record_modified: initialValue !== newValue ? 'Y' : 'N' } : record
            ));
        }
    }, [newValue])

    return (
        <div className="d-flex flex-row align-items-center justify-content-center w-100 h-100">
            <select
                className={`form-control ${touched ? erorred ? "is-invalid" : "is-valid" : ""}`}
                style={{ height: '95%' }}
                onChange={(e) => {
                    if (e.target.value !== newValue) {
                        setTouched(true);
                        setNewValue(e.target.value);
                    }
                }}
                value={newValue}
            >
                {
                    options.length > 0 ? options.map((option, index) => (
                        <option 
                            key={index} 
                            value={option.value} 
                            disabled={option.disableDependency?.value.includes(params.row[option.disableDependency?.field] as string)}
                        >
                            {option.name}
                        </option>
                    )) : (
                        <option value="">No options available</option>
                    )
                }
            </select>
        </div>
    );
}
